import React from 'react';
import { AnimatedLoader } from 'smartsuite-ui';
import PropTypes from 'prop-types';

export default function WidgetLoading(props) {
    function getWidgetLoadingClass() {
        let baseClass = 'widget-loading__overlay';
        if (props.noOverlayBackground) {
            baseClass += ' widget-loading__overlay--no-background';
        }
        return baseClass;
    }

    return (
        <div className="widget-loading">
            <div className={getWidgetLoadingClass()} />
            <span className="widget-loading__spinner">
                <AnimatedLoader />
            </span>
        </div>
    );
}

WidgetLoading.propTypes = {
    noOverlayBackground: PropTypes.bool,
};
